import { memo } from "react";
import { Icon } from "@/components/icons/Icon";
import { literals } from "@/constants/literals";
import { cn } from "@/lib/styles.utils";

interface AddPhotoButtonProps {
  openCamera: () => void;
  disabled: boolean;
}

const AddPhotoButton = ({ openCamera, disabled }: AddPhotoButtonProps) => {
  return (
    <button
      disabled={disabled}
      type="button"
      className={cn(
        "rounded-sm border border-dashed h-[calc((100vw-32px)/3)] w-[calc((100%-20px)/3)]  md:w-[calc((100%-30px)/4)] md:h-[calc(((100vw-142px)/4)/3*2)] lg:w-[calc((100%-40px)/5)] lg:h-[calc(((100vw-152px)/5)/3*2)]",
        disabled ? "border-ib-pt-color-gray-800" : "border-ib-pt-color-red-500",
      )}
      onClick={openCamera}
    >
      <div
        className={cn(
          "flex flex-col gap-1 items-center",
          disabled ? "text-ib-pt-color-gray-800" : "text-ib-pt-color-red-500",
        )}
      >
        <Icon name="addPicture" className="size-8" />
        <span className="text-ib-pt-lg">{literals.addPhoto}</span>
      </div>
    </button>
  );
};
export default memo(AddPhotoButton);
